import { render, staticRenderFns } from "./IntroChapter.vue?vue&type=template&id=8f475938&"
import script from "./IntroChapter.vue?vue&type=script&lang=js&"
export * from "./IntroChapter.vue?vue&type=script&lang=js&"
import style0 from "./IntroChapter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports